import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@mui/joy/Grid';


import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const schema = yup.object({
    name_ar: yup.string().required("هذا الحقل مطلوب"),
    name_en: yup.string().required("هذا الحقل مطلوب"),
})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default function StepTwo({
    getDataFromStepTwoNameAr, 
    getDataFromStepTwoNameEn,
    dataObjNameAr,
    dataObjNameEn,
}) {
    const [valueTitleAr, setValueTitleAr] = useState('');
    const [valueTitleEn, setValueTitleEn] = useState('');

    const submitNameAr = (e) => {
        setValueTitleAr(e.target.value)
        getDataFromStepTwoNameAr(e.target.value)
    }

    const submitNameEn = (e) => {
        setValueTitleEn(e.target.value)
        getDataFromStepTwoNameEn(e.target.value)

    }

    const getDataInputs = () => {
        setValueTitleAr(dataObjNameAr)
        setValueTitleEn(dataObjNameEn)
        
    } 
    
    useEffect(() => {
        getDataInputs();
    },[])

    return (
        <Grid
            container
            direction='row'
            spacing={3}
        >
            <Grid xs={12}>
                    <FormControl sx={{ width: '50%' }}>
                        <FormLabel sx={{fontSize:'16px', color:'#434448'}}>اسم الموديل باللغة العربية</FormLabel>
                        <Input 
                            placeholder="ادخل اسم الموديل هنا....." 
                            sx={{borderRadius:'30px', height:'60px'}}
                            value={valueTitleAr}
                            onChange={submitNameAr}
                            />
                    </FormControl>
            </Grid>
            <Grid xs={12}>
                    <FormControl sx={{ width: '50%' }}>
                        <FormLabel sx={{fontSize:'16px', color:'#434448'}}>اسم الموديل باللغة الانجليزية</FormLabel>
                        <Input 
                            placeholder="Model name here....." 
                            sx={{borderRadius:'30px', height:'60px', direction:'ltr'}}
                            value={valueTitleEn}
                            onChange={submitNameEn}
                            />
                    </FormControl>
            </Grid>

        </Grid>
    );
}